<template>
  <div class="invisible-scrollbar">
    <v-card class="manage-user-shell" style="display: contents">
      <div class="manage-user-page">
        <div class="page-title">
          {{ $t("message.UserManagement") }}
        </div>
        <v-card-text class="manage-user-content">
          <div class="search-section">
                <v-text-field
                  :placeholder="$t('message.Search')"
                  :aria-label="$t('message.Search')"
                  v-model="search"
                  @keyup.enter="SearchDataUser(search)"
                  clearable
                  outlined
                  hide-details
                  class="search-field"
                >
                  <template v-slot:append>
                    <img
                      :src="require('@/assets/icons/search-normal.png')"
                      alt=""
                      class="search-normal-icon"
                    />
                  </template>
                </v-text-field>
          </div>

          <v-card elevation="0" class="table-card">
            <div class="table-scroll">
            <v-data-table
              :headers="headers"
              :items="ListData"
              hide-default-footer
              class="data-table"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              single-line
              hide-details
            >
              <template
                v-slot:item="{ item, index }"
              >
                <tr>
                  <td class="cell">{{ no_run + (index + 1) }}</td>
                  <td class="cell">{{ item.username }}</td>
                  <td class="cell">
                    {{ item.firstname + " " + item.lastname }}
                  </td>
                  <td class="cell">{{ item.email }}</td>
                  <td class="cell">{{ item.roleName }}</td>
                  <!-- <td class="text-center">
                    <v-icon :color="item.parkingLot ? 'green' : 'red'">
                      {{
                        item.parkingLot
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td> -->
                  <td class="text-center">
                    <v-icon :color="item.redemption ? 'green' : 'red'">
                      {{
                        item.redemption
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td>

                  <td class="text-center">
                    <v-icon :color="item.manageUser ? 'green' : 'red'">
                      {{
                        item.manageUser
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td>
                  <td class="py-2 text-center">
                    <v-btn
                      :color="item.roleName == 'WaitApprove' ? GetColor(item.active, item.roleName) : GetColor(item.active, null)"
                      rounded
                      class="text-capitalize status-pill"
                      depressed
                    >
                      <span
                        v-if="item.roleName == 'WaitApprove'"
                        :style="{
                          color: GetColorText(item.active, item.roleName),
                        }"
                      >
                        {{ $t("message.WaitForApprove") }}
                      </span>
                      <span
                        v-else
                        :style="{ color: GetColorText(item.active, null) }"
                      >
                        {{ item.active ? "Active" : "Inactive" }}
                      </span>
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      class="mx-1"
                      fab
                      small
                      dark
                      color="#252122"
                      aria-label="Edit user"
                      @click="OpenUserDetailDialog(item.userID, item.statusUse)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>

                    <!-- <v-btn
                      class="mx-1"
                      fab
                      small
                      dark
                      :color="item.active ? 'red' : 'green'"
                      @click="
                        OpenChangeActiveUserDialog(
                          item.userName,
                          item.userID,
                          item.active
                        )
                      "
                    >
                      <v-icon>
                        {{
                          item.active ? "mdi-trash-can-outline" : "mdi-restore"
                        }}
                      </v-icon>
                    </v-btn> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
            </div>
            <v-row class="table-footer" align="center" justify="space-between">
              <v-col cols="12" md="3" class="d-none d-md-block"></v-col>

              <v-col cols="12" md="4" class="pagination-column text-center">
                <v-pagination
                  v-model="page"
                  :length="pageCount"
                  @input="ChangePage(page)"
                ></v-pagination>
              </v-col>

              <v-col cols="12" md="2" class="items-per-page-column">
                <v-autocomplete
                  dense
                  solo
                  v-model="itemsPerPage"
                  @input="ChangePerPage(itemsPerPage)"
                  :items="items"
                  label="Items/page"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>

    <v-dialog v-model="UserDetailDialog" persistent max-width="750px">
      <v-card class="manage-user-dialog-card">
        <v-card-title
          class="manage-user-dialog-header"
        >
          <span class="manage-user-dialog-title">
            {{ $t("message.ManageUser") }}
          </span>
          <v-btn class="dialog-close-btn" icon @click="UserDetailDialog = false">
            <v-icon color="white" size="30">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="manage-user-dialog-body">
          <div class="section-header mt-3">
            <img
              :src="require('@/assets/icons/frame.png')"
              alt=""
              class="section-header-icon mr-3"
            />
            <span>{{ $t("message.UserInformation") }}</span>
          </div>

          <v-row class="dialog-form-row">
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Username')"
                dense
                outlined
                :disabled="EditStatus"
                v-model="Username"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                :label="$t('message.Password')"
                placeholder="Enter password"
                :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="ShowPassword ? 'text' : 'password'"
                @click:append="ShowPassword = !ShowPassword"
                v-model="Password"
              />
            </v-col>
          </v-row>
          <v-row class="dialog-form-row">
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Tenant')"
                dense
                outlined
                disabled
                v-model="Tenant"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="RoleListData"
                item-text="roleName"
                item-value="roleId"
                dense
                outlined
                :label="$t('message.RoleName')"
                v-model="RoleId"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="dialog-form-row">
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.FirstName')"
                dense
                outlined
                v-model="FirstName"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.LastName')"
                dense
                outlined
                v-model="LastName"
              />
            </v-col>
          </v-row>
          <v-row class="dialog-form-row">
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Email')"
                dense
                outlined
                v-model="Email"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Telephone')"
                dense
                outlined
                v-model="Telephone"
              />
            </v-col>
          </v-row>
          <v-row class="dialog-status-row">
            <v-col cols="12">
              <v-radio-group row v-model="ActiveStatus" class="dialog-radio-group">
                <v-radio :label="$t('message.Active')" value="1"></v-radio>
                <v-radio :label="$t('message.InActive')" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <template v-if="RedemptionStatus">
            <v-divider class="dialog-divider"></v-divider>

            <div class="section-header">
              <img
                :src="require('@/assets/icons/frame.png')"
                alt=""
                class="section-header-icon mr-3"
              />
              <span>{{ $t("message.RedemptionSettings") }}</span>
            </div>

            <v-row class="dialog-form-row redemption-row">
              <v-col cols="12" md="6">
                <v-select
                  :items="DepartmentList"
                  item-text="departmentName"
                  item-value="departmentId"
                  dense
                  outlined
                  :label="$t('message.Department')"
                  v-model="Department"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  :items="RedemptionTypeList"
                  item-text="redempType_Name"
                  item-value="redempType_Id"
                  dense
                  outlined
                  :label="$t('message.RedemptionType')"
                  v-model="RedemptionType"
                />
              </v-col>
            </v-row>

            <v-row class="dialog-form-row">
              <v-col cols="12" md="6">
                <v-select
                  :items="UserLevelList"
                  item-text="userLevel_Name"
                  item-value="userLevel_Id"
                  dense
                  outlined
                  :label="$t('message.UserLevel')"
                  v-model="UserLevel"
                />
              </v-col>
            </v-row>
          </template>
          <v-row class="dialog-submit-row" justify="center">
            <v-col cols="12" class="dialog-submit-column">
              <v-btn
                block
                color="#231F20"
                class="white--text dialog-submit-btn"
                @click="UpdateDataUser()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ChangeActiveUserDialog" persistent width="500">
      <v-card>
        <v-card-title>
          <template v-if="Active_Register">
            <h4>คุณต้องการ Inactive Username นี้ ใช่หรือไม่ ?</h4>
          </template>
          <template v-else>
            <h4>คุณต้องการ Active Username นี้ ใช่หรือไม่ ?</h4>
          </template>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6"></v-col>
            <v-col cols="12" md="6"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                block
                color="#5cb85c"
                style="color: white"
                @click="ChangeActiveUsername()"
                class="rounded-lg"
                x-large
                >YES</v-btn
              >
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                block
                color="#d9534f"
                style="color: white"
                @click="CloseChangeActiveUserDialog()"
                class="rounded-lg"
                x-large
                >NO</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageUser",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,

      LoadingDialog: false,
      UserDetailDialog: false,
      ChangeActiveUserDialog: false,

      items: [10, 15, 20, 50, 100],
      pageCount: 0, //จำนวนหน้าทั้งหมด
      page: 1, //อยู่หน้าที่เท่าไร
      itemsPerPage: 10, //จำนวนรายการต่อหน้า
      search: "",
      no_run: 0,

      UserName_Register: "",
      UserId_Register: 0,
      Active_Register: false,

      RoleName_User: "",
      StatusUse_User: false,

      ListData: [],
      RoleListData: [],
      RoleId: 0,
      UserID: null,
      MemberList: [],
      RedemptionTypeList: [],
      DepartmentList: [],
      UserLevelList: [],

      SearchMemberID: null,
      FirstName: "",
      LastName: "",
      Username: "",
      Password: "",
      MemberID: "",
      CardID: "",
      TenantID: "",
      Tenant: "",
      Email: "",
      Telephone: "",
      ShowPassword: false,
      RedemptionType: null,
      UserLevel: null,
      ActiveStatus: null,
      Department: null,
      RedemptionStatus: false,

      EditStatus: false,
      projectID: localStorage.getItem("ProjectSiteID"),
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.Username"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.FullName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Email"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.RoleName"),
          align: "left",
          sortable: false,
        },
        // {
        //   text: this.$t("message.Handheld"),
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: this.$t("message.Redemption"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.ManageUser"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    headersMobile() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "Username",
          align: "left",
          sortable: false,
        },
        {
          text: "FullName",
          align: "left",
          sortable: false,
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
        },
        {
          text: "Role Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    await self.GetUserList();
    await self.getMasMember();
    await self.getRedemptionDepartment();
    await self.getDepartment();
    await self.getUserStampLevel();
    await self.GetRoleUser();
  },

  methods: {
    CreateNewUser() {
      let self = this;
      self.UserDetailDialog = true;
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.ShowPassword = false;
      } else {
        x.type = "password";
        self.ShowPassword = true;
      }
    },

    getMasMember() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}User/getMasMember`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.MemberList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    getRedemptionDepartment() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getRedemptionDepartment`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.RedemptionTypeList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    getDepartment() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getDepartment`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.DepartmentList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    getUserStampLevel() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getUserStampLevel`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.UserLevelList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    getMasMemberByMemberID(member) {
      let self = this;
      if (member != null) {
        self.RedemptionType = null;
        self.UserLevel = null;
        self.Department = null;
        self.RedemptionStatus = null;
        let temp = {
          MemberID: member,
          userID: self.UserID,
        };
        axios
          .post(`${self.url}Management/getMasMemberByMemberID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              // console.log(response.data.data);
              self.UserID = response.data.data.userID;
              self.RoleId = response.data.data.roleID;
              self.SearchMemberID = response.data.data.member_Id;
              // self.Username = response.data.data.username;
              // self.Password = response.data.data.password;
              self.MemberID = response.data.data.member_Id;
              // self.CardID = response.data.data.card_id;
              self.TenantID = response.data.data.tenantID;
              self.Tenant = response.data.data.tenant;
              self.FirstName = response.data.data.firstname;
              self.LastName = response.data.data.lastname;
              self.Email = response.data.data.email;
              self.Telephone = response.data.data.telephone;
              self.ActiveStatus =
                response.data.data.active == true
                  ? "1"
                  : response.data.data.active == false
                  ? "2"
                  : null;
              self.RedemptionType = response.data.data.redemptionType;
              self.UserLevel = response.data.data.userStampLevel;
              self.Department = response.data.data.departmentID;
              self.RedemptionStatus = response.data.data.redemption;
            }
          })
          .catch(function (error) {
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

            Swal.fire({
              icon: "warning",
              width: 900,
              text: message,
            });
          });
      }
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        projectID: self.projectID,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
        projectID: self.projectID,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    GetUserList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
        projectID: self.projectID,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    SearchDataUser(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
        projectID: self.projectID,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            // self.pageCount = Math.ceil(
            //   response.data.data.count / self.itemsPerPage
            // );
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    ChangeActiveUsername() {
      let self = this;
      let temp = {
        UserId: self.UserId_Register,
        Active: !self.Active_Register,
      };
      axios
        .post(`${self.url}Management/ChangeActiveUsername`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.ChangeActiveUserDialog = false;
            self.GetUserList();
          }
        })
        .catch(function (error) {
          self.ChangeActiveUserDialog = false;
          // self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    GetMemberDetailByUserId() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        UserId: self.UserId_Register,
      };
      axios
        .post(`${self.url}Management/GetMemberDetailByUserId`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.EditStatus = true;
            self.BindingDataUser(response.data.data);
          } else if (response.data.status == 1) {
            Swal.fire({
              icon: "warning",
              title: "warning",
              width: 500,
              text: response.data.message,
            });
            self.EditStatus = true;
            self.BindingDataUser(response.data.data);
          }
        })
        .catch(function (error) {
          self.ChangeActiveUserDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    BindingDataUser(data) {
      let self = this;
      self.UserID = data.userID;
      self.RoleId = data.roleID;
      self.Username = data.username;
      self.Password = data.password;
      self.MemberID = data.member_Id;
      self.CardID = data.card_id;
      self.TenantID = data.tenantID;
      self.Tenant = data.tenant;
      self.FirstName = data.firstname;
      self.LastName = data.lastname;
      self.Email = data.email;
      self.Telephone = data.telephone;
      self.ActiveStatus =
        data.active == true ? "1" : data.active == false ? "2" : null;
      self.RedemptionType = data.redemptionType;
      self.UserLevel = data.userStampLevel;
      self.Department = data.departmentID;
      self.RedemptionStatus = data.redemption;
      self.UserDetailDialog = true;
    },

    UpdateDataUser() {
      let self = this;
      let temp = {
        UserId: self.UserId_Register,
        MemberId: self.MemberID,
        roleId: self.RoleId,
        Username: self.Username,
        Password: self.Password,
        FirstName: self.FirstName,
        LastName: self.LastName,
        Telephone: self.Telephone,
        Email: self.Email,
        Tenant: self.TenantID,
        Department: self.Department == "" ? null : self.Department,
        RedemptionType: self.RedemptionType,
        UserStampLevel: self.UserLevel,
        active: self.ActiveStatus == "1" ? true : false,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}Management/UpdateDataUser`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              text: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.UserDetailDialog = false;
            self.GetUserList();
          }
        })
        .catch(function (error) {
          self.ChangeActiveUserDialog = false;
          Swal.fire({
            icon: "error",
            width: 500,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
      // if (temp.memberId === "") {
      //   Swal.fire({
      //     icon: "error",
      //     width: 500,
      //     text: "กรุณาใส่กรอกข้อมูลให้ครบถ้วน",
      //   });
      // } else {

      // }
    },

    GetRoleUser() {
      let self = this;
      axios
        .get(`${self.url}Management/GetRoleName`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RoleListData = response.data.data;
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
          self.ChangeActiveUserDialog = false;
        });
    },

    OpenUserDetailDialog(userid, statusUse) {
      let self = this;
      self.ClearDataUser();
      // self.UserDetailDialog = true;
      self.UserId_Register = userid;
      self.StatusUse_User = statusUse;
      self.GetMemberDetailByUserId();
      // self.GetRoleUser();
    },

    CloseUserDetailDialog() {
      let self = this;
      self.ClearDataUser();
      self.UserDetailDialog = false;
      self.MemberId_MasMember = "";
      self.CardId_MasMember = "";
      self.FullName_MasMember = "";
      self.TenantName_MasMember = "";
    },
    OpenChangeActiveUserDialog(username, userid, active) {
      let self = this;
      self.ChangeActiveUserDialog = true;
      self.UserName_Register = username;
      self.UserId_Register = userid;
      self.Active_Register = active;
    },

    CloseChangeActiveUserDialog() {
      let self = this;
      self.ChangeActiveUserDialog = false;
    },

    ClearDataUser() {
      let self = this;
      self.Username_Register = "";
      self.FirstName = "";
      self.LastName = "";
      self.Username = "";
      self.Password = "";
      self.MemberID = "";
      self.CardID = "";
      self.TenantID = "";
      self.Tenant = "";
      self.Email = "";
      self.RoleId = 0;
      self.Telephone = "";
      self.RedemptionType = null;
      self.UserLevel = null;
      self.ActiveStatus = null;
      self.Department = null;
      self.RedemptionStatus = false;
    },

    GetColor(value, role) {
      if(role != null){
        return "#FFA014";
      }
      else{
        if (value == true) {
          return "#88C982";
        } else {
          return "#EF8585";
        }
      }
    },

    GetColorText(value, role) {
      if (role != null) {
        return "white";
      } else {
        return "#514D4E";
      }
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-display: swap;
}

* >>> .v-data-table-header {
  background-color: #231f20;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.page-title {
  color: #231f20;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0.02em;
  line-height: 1.25;
  padding-top: 42px;
  text-align: center;
}

.cell {
  color: #514d4e;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px !important;
  padding: 14px 16px;
  white-space: nowrap;
}

.data-table >>> tbody td.cell {
  font-size: 18px !important;
}

.data-table {
  color: #514d4e;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  min-width: 1120px;
}

.v-data-table-header th {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  letter-spacing: 0.025em;
  background-color: #231f20 !important;
  color: white !important;
  height: 58px !important;
}

.manage-user-page {
  min-height: calc(100vh - 120px);
  padding: 0 3.75vw 56px;
}

.manage-user-content {
  padding: 0 !important;
}

.search-section {
  margin: 72px auto 68px;
  max-width: 940px;
}

.search-field >>> .v-input__slot {
  min-height: 58px;
  border-radius: 30px !important;
  background: #fff;
}

.search-field >>> fieldset {
  border-color: #3f3b3c !important;
}

.search-field >>> .v-label,
.search-field >>> input {
  color: #514d4e !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 17px;
}

.search-field >>> .v-label {
  left: 18px !important;
}

.search-field >>> input {
  padding-left: 18px;
}

.search-field >>> .v-icon {
  color: #231f20 !important;
  font-size: 28px;
}

.search-normal-icon {
  display: block;
  height: 24px;
  width: 24px;
}

.search-field >>> .v-input__append-inner {
  margin-top: 15px;
}

.table-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 14px rgba(37, 33, 34, 0.16) !important;
  overflow: hidden;
}

.table-scroll {
  overflow-x: auto;
}

.data-table >>> tbody tr:nth-child(odd) {
  background: #faf9f8;
}

.data-table >>> tbody tr:hover {
  background: #f1efee !important;
}

.data-table >>> tbody td {
  height: 68px;
  border-bottom: 0 !important;
}

.data-table >>> .v-icon {
  font-size: 34px;
}

.data-table >>> .green--text {
  color: #079900 !important;
  caret-color: #079900 !important;
}

.data-table >>> .red--text {
  color: #d90000 !important;
  caret-color: #d90000 !important;
}

.data-table >>> .status-pill,
.data-table >>> .status-pill * {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px !important;
}

.data-table >>> .v-btn--fab.v-size--small {
  height: 36px;
  width: 36px;
}

.data-table >>> .v-btn--fab.v-size--small .v-icon {
  font-size: 20px;
}

.status-pill {
  min-width: 98px !important;
  height: 36px !important;
}

.table-footer {
  min-height: 110px;
  margin: 0 !important;
  padding: 14px 20px 8px;
  position: relative;
}

@media (min-width: 960px) {
  .pagination-column {
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  .items-per-page-column {
    margin-left: auto;
  }
}

.items-per-page-column >>> .v-input__slot {
  border-radius: 24px !important;
  height: 35px;
  min-height: 35px;
}

.items-per-page-column {
  flex: 0 0 93px;
  max-width: 93px;
  padding: 0 !important;
}

.items-per-page-column >>> .v-input__control {
  height: 35px;
  min-height: 35px;
}

.items-per-page-column >>> .v-select__selection,
.items-per-page-column >>> .v-label,
.pagination-column >>> .v-pagination__item {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}

.items-per-page-column >>> .v-text-field__details {
  display: none;
}

.pagination-column >>> .v-pagination__item,
.pagination-column >>> .v-pagination__navigation {
  border-radius: 9px;
  box-sizing: border-box;
  height: 46px;
  min-width: 46px;
}

.pagination-column >>> .v-pagination__item {
  border: 2px solid transparent;
}

.pagination-column >>> .v-pagination__navigation {
  background: #231f20 !important;
  color: #fff;
  opacity: 1 !important;
}

.pagination-column >>> .v-pagination__navigation--disabled {
  background: #231f20 !important;
  opacity: 1 !important;
}

.pagination-column >>> .v-pagination__navigation .v-icon {
  color: #fff;
}

.pagination-column >>> .v-pagination__item--active {
  background: #fff !important;
  border-color: #231f20 !important;
  color: #231f20 !important;
}

.search-field >>> .v-input__slot:focus-within,
.pagination-column >>> button:focus-visible,
.data-table >>> button:focus-visible {
  outline: 3px solid rgba(18, 100, 150, 0.4);
  outline-offset: 2px;
}

.rounded-lg {
  border-radius: 12px !important;
}

.rounded-xl {
  border-radius: 16px !important;
}

h1 {
  letter-spacing: 0.5px;
}

.v-text-field input {
  font-size: 15px;
}

.section-header {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px;
  font-weight: 400;
  color: #231f20;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.section-header-icon {
  display: block;
  height: 18px;
  object-fit: contain;
  width: 18px;
}

.manage-user-dialog-card {
  border-radius: 16px !important;
  height: 671px;
  overflow: hidden;
}

.manage-user-dialog-header {
  align-items: center;
  background: #231f20;
  color: #fff;
  display: flex;
  height: 46px;
  justify-content: center;
  padding: 0 64px !important;
  position: relative;
}

.manage-user-dialog-title {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 25px;
  font-weight: 400;
  letter-spacing: 0.02em;
}

.dialog-close-btn {
  position: absolute;
  right: 8px;
  top: 3px;
}

.manage-user-dialog-body {
  color: #231f20 !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px;
  height: calc(671px - 46px);
  overflow-y: auto;
  padding: 18px 28px 24px !important;
}

.dialog-form-row {
  margin: 0 -6px !important;
}

.dialog-form-row > .col,
.dialog-status-row > .col {
  padding: 3px 6px !important;
}

.manage-user-dialog-body >>> .v-text-field__details {
  display: none;
}

.manage-user-dialog-body >>> .v-text-field,
.manage-user-dialog-body >>> .v-select,
.manage-user-dialog-body >>> .v-label,
.manage-user-dialog-body >>> input,
.manage-user-dialog-body >>> .v-select__selection,
.manage-user-dialog-body >>> .v-radio .v-label {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}

.manage-user-dialog-body >>> .v-text-field,
.manage-user-dialog-body >>> .v-select {
  max-width: 300px;
  width: 300px;
}

.manage-user-dialog-body >>> .v-input__slot {
  border-radius: 16px !important;
}

.manage-user-dialog-body >>> .v-text-field--outlined > .v-input__control > .v-input__slot {
  height: 55px;
  min-height: 55px;
}

.manage-user-dialog-body >>> .v-text-field--outlined fieldset {
  border-color: #403c3d;
}

.manage-user-dialog-body >>> .v-text-field--outlined .v-label {
  color: #9b9798;
  font-size: 15px !important;
  height: auto !important;
  line-height: 1.5 !important;
  overflow: visible !important;
}

.manage-user-dialog-body >>> .v-text-field--outlined .v-label--active {
  top: 8px;
  transform: translateY(0) scale(0.75) !important;
  transform-origin: top left;
}

.manage-user-dialog-body >>> .v-text-field--outlined legend {
  width: 0 !important;
}

.manage-user-dialog-body >>> .v-text-field--outlined input {
  padding-top: 20px;
}

.manage-user-dialog-body >>> .v-text-field--outlined .v-select__selection {
  margin-top: 20px;
}

.manage-user-dialog-body >>> .v-text-field input,
.manage-user-dialog-body >>> .v-select__selection {
  color: #302c2d;
  font-size: 18px;
}

.dialog-status-row {
  margin: 0 -6px !important;
}

.dialog-radio-group {
  margin: 0 !important;
  padding-top: 0 !important;
}

.dialog-radio-group >>> .v-radio {
  margin-right: 34px;
}

.dialog-radio-group >>> .v-radio .v-label {
  color: #514d4e;
  font-size: 18px;
}

.dialog-radio-group >>> .v-icon {
  color: #231f20 !important;
  font-size: 26px;
}

.dialog-divider {
  border-color: #8c8889 !important;
  margin: 12px 0 14px;
}

.redemption-row {
  margin-top: 6px !important;
}

.dialog-submit-row {
  margin-top: 16px;
}

.dialog-submit-column {
  flex: 0 0 150px;
  max-width: 150px;
  padding: 0 !important;
}

.dialog-submit-btn {
  border-radius: 40px !important;
  box-shadow: 0 9px 12px rgba(35, 31, 32, 0.3) !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px !important;
  font-weight: 400;
  height: 40px !important;
  letter-spacing: 0.02em;
  text-transform: none;
}

.rounded-xl {
  border-radius: 16px !important;
}

.v-text-field input,
.v-select input {
  font-size: 15px;
}

@media (max-width: 959px) {
  .manage-user-page {
    padding: 0 16px 36px;
  }

  .page-title {
    font-size: 26px;
    padding-top: 28px;
  }

  .search-section {
    margin: 36px auto 34px;
  }

  .search-field >>> .v-input__slot {
    min-height: 52px;
  }

  .table-card {
    border-radius: 10px !important;
  }

  .table-footer {
    padding: 10px 8px 14px;
  }

  .pagination-column,
  .items-per-page-column {
    padding-bottom: 4px;
    padding-top: 4px;
  }

  .items-per-page-column {
    margin: 0 auto;
    max-width: 93px;
    padding: 0 !important;
  }

  .manage-user-dialog-header {
    height: 56px;
  }

  .manage-user-dialog-title {
    font-size: 18px;
  }

  .dialog-close-btn {
    right: 12px;
    top: 8px;
  }

  .manage-user-dialog-card {
    height: calc(100vh - 32px);
  }

  .manage-user-dialog-body {
    height: calc(100vh - 88px);
    padding: 28px 18px 38px !important;
  }

  .manage-user-dialog-body >>> .v-text-field,
  .manage-user-dialog-body >>> .v-select {
    max-width: 100%;
    width: 100%;
  }

  .section-header {
    font-size: 18px;
  }

  .manage-user-dialog-body >>> .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 60px;
  }

  .dialog-radio-group >>> .v-radio {
    margin-bottom: 12px;
    margin-right: 32px;
  }

  .dialog-divider {
    margin: 20px 0 24px;
  }

  .dialog-submit-row {
    margin-top: 30px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
